import { registrarWebPush } from "modules/WebPushService";
import { useCallback, useEffect, useState } from "react";
import { isDevHelper } from "utils/isDevMode.utils";
import { isIPhone } from "utils/isIphone";
import { NotificationsCookies } from "utils/notificationsCookies";
import { reportGA4 } from "utils/pushDataLayer";

const isDev = isDevHelper();

export const useWebPush = () => {
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [navigatorStatusPermission, setNavigatorStatusPermission] =
    useState(null);

  const onClickGrantedPermission = async () => {
    NotificationsCookies.insert(true);
    setNavigatorStatusPermission("granted");
    setIsOpenAlert(false);

    try {
      await registrarWebPush({
        isDev,
      });

      reportGA4({
        event: "callback",
        customCallback: "sucesso",
        custom_title: "alerta:quero_receber_notificacoes",
      });

      return true;
    } catch (err) {
      reportGA4({
        event: "callback",
        customCallback: "erro",
        custom_title: "alerta:quero_receber_notificacoes",
      });
    }

    return false;
  };

  const onRequestPermission = async () => {
    reportGA4({
      customTitle: "notificacoes:aceitar",
    });
    if (!("Notification" in window)) return;
    const permission = await Notification.requestPermission();
    if (permission === "granted") onClickGrantedPermission();
    else NotificationsCookies.insert(false);
  };

  const onCloseClickAlert = () => {
    reportGA4({
      customTitle: "notificacoes:recusar",
    });

    NotificationsCookies.insert(true);
    setIsOpenAlert(false);
  };

  const onOpenClickAlert = () => {
    NotificationsCookies.insert(false);
    setIsOpenAlert(true);
  };

  const onRequestPermissionsWebPushAlerts = useCallback(() => {
    if (!("permissions" in navigator)) {
      setNavigatorStatusPermission(null);
      setIsOpenAlert(true);
      return;
    }

    const webPushCookie = NotificationsCookies.get();

    if (webPushCookie) {
      setIsOpenAlert(false);
      return;
    }

    let isMounted = true;

    navigator.permissions.query({ name: "notifications" }).then((result) => {
      if (!isMounted) return;

      if (isIPhone()) {
        setIsOpenAlert(false);
        return;
      }

      const mappedState = result.state === "prompt" ? "default" : result.state;
      setNavigatorStatusPermission(mappedState);

      if (!webPushCookie) setIsOpenAlert(mappedState === "default");

      result.onchange = () => {
        if (!isMounted) return;

        const mappedState =
          result.state === "prompt" ? "default" : result.state;
        setNavigatorStatusPermission(mappedState);

        if (!webPushCookie) setIsOpenAlert(mappedState === "default");
      };
    });
  }, []);

  useEffect(() => {
    onRequestPermissionsWebPushAlerts();
  }, [onRequestPermissionsWebPushAlerts]);

  return {
    isOpenAlert,
    onOpenClickAlert,
    onCloseClickAlert,
    onRequestPermission,
    status: navigatorStatusPermission,
  };
};
